import { PersonLane } from '@app/modules/persons/appearances/types';
import FaceOutlinedIcon from '@mui/icons-material/FaceOutlined';
import RecordVoiceOverOutlinedIcon from '@mui/icons-material/RecordVoiceOverOutlined';
import { Chip, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type PersonsViewSourceChipsProps = {
  lane: PersonLane;
};

/**
 * "Sources" column cell in the Personas results table.
 *
 * Shows outlined "Rostro" / "Voz" chips for whichever detection types the
 * person has in the current focus range.
 */
export function PersonsViewSourceChips({ lane }: PersonsViewSourceChipsProps) {
  return (
    <Stack direction="row" spacing={0.5}>
      {lane.face.length > 0 && (
        <Chip
          size="small"
          variant="outlined"
          icon={<FaceOutlinedIcon color="secondary" />}
          label={<FormattedMessage id="logger.persons.source.face" defaultMessage="Rostro" />}
        />
      )}
      {lane.voice.length > 0 && (
        <Chip
          size="small"
          variant="outlined"
          icon={<RecordVoiceOverOutlinedIcon color="secondary" />}
          label={<FormattedMessage id="logger.persons.source.voice" defaultMessage="Voz" />}
        />
      )}
    </Stack>
  );
}
